import { Card, EmptyData } from '@wonderschool/common-base-ui';
import { useTranslation } from 'react-i18next';

import StripeConnectDocuments from '../Components/Billing/TaxForms/StripeConnectDocuments';
import PageHeader from '../Components/Shared/PageHeader';
import { useOrganization } from '../hooks/useOrganizations';

const TaxForms1099Page = () => {
  const { t } = useTranslation();
  const organization = useOrganization();
  const title = t('taxForms.title', '1099-K Tax Forms');

  // Mirror the callable's eligibility gate: it rejects orgs that aren't verified
  // for payouts (paymentsEnabled defaults to false), so gate on both here to show
  // the "No tax forms yet" empty state instead of the load-error banner.
  const hasConnectedAccount = Boolean(organization?.stripe?.accountId && organization?.stripe?.paymentsEnabled);

  return (
    <div className="container mx-auto px-4 py-8 sm:px-6 lg:px-8">
      <PageHeader pageName={title} classes="tax-forms-page" />

      <div className="mx-auto max-w-5xl">
        <div className="mb-10">
          <p className="text-base leading-relaxed text-gray-700 sm:text-lg">
            {t(
              'taxForms.description',
              'View and download the 1099-K tax forms Stripe has issued for your childcare business. Forms appear here once Stripe generates them for the tax year.'
            )}
          </p>
        </div>

        {hasConnectedAccount ? (
          <Card>
            {/* key forces a fresh mount (and a fresh Connect session) when the
                active organization changes, so one org's documents never linger. */}
            <StripeConnectDocuments key={organization!.id} organizationId={organization!.id} />
          </Card>
        ) : (
          <EmptyData
            title={t('taxForms.noPayments.title', 'No tax forms yet')}
            description={t(
              'taxForms.noPayments',
              'Tax forms are available once you set up payments. Connect a payout account from Finance & Billing settings to get started.'
            )}
          />
        )}
      </div>
    </div>
  );
};

export default TaxForms1099Page;
